import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@common/utils/api';
const BagPaymentLogos = (props) => {
    const { t } = useTranslation();
    const [allPayments, setAllPayments] = useState(null);
    const paymentlogos = useMemo(() => {
        return allPayments && [...allPayments].filter(props.mutator);
    }, [allPayments, props.mutator]);
    useEffect(() => {
        api.paymentLogos().then((data) => {
            setAllPayments(data);
            setTimeout(() => {
                props.onLoad && props.onLoad();
            }, 100);
        });
    }, []);
    return ((paymentlogos === null || paymentlogos === void 0 ? void 0 : paymentlogos.length) > 0 && (React.createElement("div", { className: "paymentslogos-list" },
        props.children,
        React.createElement("ul", { className: "inline-list" }, [...paymentlogos].splice(0, props.max).map((p, n) => (React.createElement("li", { key: n, className: `icon--payment-${p.type}` },
            React.createElement("span", null, p.label == 'mc' ? t('paymentmethod.mc') : p.label == 'cup' ? t('paymentmethod.cup') : p.label))))))));
};
BagPaymentLogos.defaultProps = {
    max: 19,
    mutator: (payment) => true,
};
export default BagPaymentLogos;
